

import React from 'react';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import Features from '../components/Features';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';
import { Page } from '../types';

interface LandingPageProps {
  theme: string;
  startWorkspaceWithPrompt: (prompt: string) => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ theme, startWorkspaceWithPrompt }) => {
  return (
    <div className="w-full">
      <Hero theme={theme} startWorkspaceWithPrompt={startWorkspaceWithPrompt} />
      <HowItWorks />
      <Features />
      <Stats />
      <Testimonials />
    </div>
  );
};

export default LandingPage;